import React, { useCallback, useRef, ChangeEvent } from 'react';
import useMount from 'react-use-v13/lib/useMount';

interface ITextAreaProps {
  value?: string;
  defaultValue?: string;
  placeholder?: string;
  shouldFocus?: boolean;
  containerStyle?: React.CSSProperties;
  children?: any;
  disabled?: boolean;
  rows?: number;
  className?: string;
  style?: React.CSSProperties;
  onChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: $FIXME) => void;
}

/** @deprecated - prefer `design-system/TextInput` (set `multiline` prop to `true`) */
const Textarea = ({ shouldFocus, containerStyle, children, ...textareaProps }: ITextAreaProps) => {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  const handleKeyDown = useCallback((e: any) => {
    e.stopPropagation();
  }, []);

  const handleKeyUp = useCallback((e: any) => {
    e.stopPropagation();
  }, []);

  useMount(() => {
    if (ref.current && shouldFocus && !textareaProps.disabled) {
      ref.current.focus();
    }
  });

  return (
    <div className="container" style={containerStyle}>
      <textarea {...textareaProps} onKeyDown={handleKeyDown} onKeyUp={handleKeyUp} ref={ref}>
        {children}
      </textarea>

      <style jsx>{`
        .container {
          position: relative;
          height: 100%;
          width: 100%;
        }

        textarea {
          background-color: var(--color-RemoGray01);
          padding: 10px 12px;
          box-sizing: border-box;
          border: 0;
          transition: var(--form-transition);
          width: 100%;
          min-height: 100%;
          resize: none;

          border-radius: 8px;

          font-family: var(--font-family);
          font-size: 14px;
        }

        textarea ::placeholder {
          font-weight: normal;
          color: rgba(0, 0, 0, 0.5);
        }

        textarea:focus {
          background-color: var(--bg-form-focus);
        }

        .container.has-icon input {
          text-indent: 20px;
        }
      `}</style>
    </div>
  );
};

export default Textarea;
